import { ISelectOption } from '../../ui-toolkit';
import { IRoleData } from './IRole';
import { labelComparator } from '../../utilities/labelComparator';

export const rolesOptions = (roles: IRoleData[]): ISelectOption[] =>
  roles
    .map((role) => ({
      label: role.label,
      value: role.name,
    }))
    .toSorted(labelComparator);
